import { useState } from 'react';

import { NoteView } from '@ndvr/customer-api';

import { ShareDialog } from '@/components/ShareDialog';
import { useAdHocMeetingTeamMembers } from '@/modules/ad-hoc-meeting-queries';
import { useAuthContext } from '@/views/auth/Auth';

import { MEETING_MINUTES_LINK_CLASSES } from '../meeting-minutes-list-utils';
import { useShareMeetingNote } from '../meeting-minutes-share-queries';

// Sharing links the meeting to the recipients' calendars, which is what grants them access
// to its notes, so the copy talks about the calendar rather than implying the note is sent.
const ShareMeetingNoteDialog = ({ note, onClose }: { note: NoteView; onClose: () => void }) => {
    const { selectedTenants, user } = useAuthContext();
    // The endpoint only accepts recipients who are non-archived tenant team members with a
    // connected calendar — exactly the set this hook already computes for the Invite Claire flow.
    const teamMembersQuery = useAdHocMeetingTeamMembers(
        selectedTenants.map(({ tenantGUID }) => tenantGUID),
        user?.profileGUID,
    );
    const shareMutation = useShareMeetingNote(note);

    return (
        <ShareDialog
            open
            onOpenChange={(nextOpen) => {
                if (!nextOpen) {
                    onClose();
                }
            }}
            title="Share meeting note"
            description="The meeting and its notes will appear on the selected teammates' calendars and Meeting Minutes. Only teammates with a connected calendar can be selected."
            emptyLabel="No teammates with a connected calendar are available."
            recipients={teamMembersQuery}
            mutation={shareMutation}
        />
    );
};

export const MeetingMinutesShareNote = ({ note }: { note: NoteView }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button type="button" className={MEETING_MINUTES_LINK_CLASSES} onClick={() => setIsOpen(true)}>
                Share
            </button>
            {/* Mounted only while open: the dialog's eligibility hook fetches tenant teams and
                connected-calendar state, which would otherwise fire once per card in the list. */}
            {isOpen && <ShareMeetingNoteDialog note={note} onClose={() => setIsOpen(false)} />}
        </>
    );
};
